import React, { useEffect, useState } from "react";
import { Bar, Column } from "@ant-design/plots";
import { Modal, Spin, Row, Col, Table } from "antd";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";

// Redux
import { connect } from "react-redux";
import {
  getUserRoleId,
  getAllDepartmentList,
  getLocations,
} from "redux/selectors";
import COLORS from "common/Colors";
import {
  find,
  get,
  isNaN,
  map,
  max,
  random,
  reduce,
  differenceBy,
  concat,
  chain,
  groupBy,
  toPairs,
  zipObject,
  size,
} from "lodash";
import { CALL_API } from "common/API";
import { dateInDetail } from "utils/Date";
import LocationCell from "molecules/LocationCell";

const StyledModal = styled(Modal)`
  width: 700px !important;
  z-index: 10;
  .ant-modal-header {
    text-transform: uppercase;
    max-width: 95%;
  }
`;

const SmallModal = styled(Modal)`
  width: 700px !important;
  .ant-modal-body {
    overflow-y: auto;
  }
  .ant-modal-header {
    text-transform: uppercase;
    max-width: 95%;
  }
`;
const StyledColumn = styled(Bar)`
  padding: 10px;
`;

function DepartmentAttendanceReport({
  displayModal,
  toggleModal,
  reportType,
  reportColor,
  allDepartmentList,
  list,
  name,
  lateListData,
  onTimeList,
  leaveList,
  absentList,
  locationList,
}) {
  const { t } = useTranslation();
  const [displayReportLoader, toggleReportLoader] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [key, setKey] = useState(Math.random());
  const [detailedData, setDetailedData] = useState([]);
  console.log("detaileddaata-->", detailedData);
  const [reportList, setReportList] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  console.log("filterdata-->", filteredData);
  const [selectedDept, setSelectedDept] = useState("");

  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (name === "Absent") {
      setDetailedData(
        absentList === (null || undefined || "") ? [] : absentList
      );
    }
    if (name === "onTime") {
      setDetailedData(
        onTimeList === (null || undefined || "") ? [] : onTimeList
      );
    }
    if (name === "Late") {
      setDetailedData(
        lateListData === (null || undefined || "") ? [] : lateListData
      );
    }
    if (name === "Leave") {
      setDetailedData(leaveList === (null || undefined || "") ? [] : leaveList);
    }
  }, [name, detailedData, filteredData, reportType]);

  const handleResize = () => {
    setKey(Math.random());
  };

  const columns = [];

  if (reportType === "Leave") {
    columns.push({
      title: t("Name"),
      dataIndex: "name",
      key: "name",
      align: "center",
    });
    columns.push({
      title: t("Department"),
      dataIndex: "departmentName",
      key: "departmentName",
      align: "center",
    });
    columns.push({
      title: t("Leave Category"),
      dataIndex: "leave_category_name",
      key: "leave_category_name",
      align: "center",
    });
    columns.push({
      title: t("Start date"),
      dataIndex: "start_date",
      key: "start_date",
      align: "center",
      render: (start_date) => {
        if (start_date === "") return "-";
        const { date: day_th, shortMonthName, year } = dateInDetail(start_date);
        return `${day_th} ${shortMonthName} ${year}`;
      },
    });
    columns.push({
      title: t("End date"),
      dataIndex: "end_date",
      key: "end_date",
      align: "center",
      render: (end_date) => {
        if (end_date === "") return "-";
        const { date: day_th, shortMonthName, year } = dateInDetail(end_date);
        return `${day_th} ${shortMonthName} ${year}`;
      },
    });
    columns.push({
      title: t("No.of leave days"),
      dataIndex: "number_of_days",
      key: "number_of_days",
      align: "center",
    });
  } else if (reportType === "Present") {
    columns.push({
      title: t("Name"),
      dataIndex: "fullname",
      key: "fullname",
      align: "center",
    });
    columns.push({
      title: t("Department"),
      dataIndex: "departmentName",
      key: "departmentName",
      align: "center",
    });
    if (name === "onTime") {
      console.log("commming");
      columns.push({
        title: t("Station Name"),
        dataIndex: "loginlocationname",
        key: "loginlocationname",
        align: "center",
      });
      columns.push({
        title: <div>{"Location"}</div>,
        dataIndex: "location",
        key: "loginlatitude",
        width: "50%",
        align: "center",
        render: (_, record) => {
          const findLocation = locationList?.find(
            (item) => item?.location_id === String(record?.loginlocationid)
          );
          console.log("findLocation", findLocation);
          const hasother =
            findLocation?.login_from_anywhere === 1 ? true : false;
          console.log("hasother", hasother);
          return (
            <LocationCell
              lat={record.loginlatitude}
              lng={record.loginlongitude}
              hasother={hasother}
              locationName={record.loginlocationname}
            />
          );
        },
      });
      columns.push({
        title: t("Check-In Time"),
        dataIndex: "checkintime",
        key: "checkintime",
        align: "center",
        render: (checkinTime) => {
          return `${checkinTime}`;
        },
      });
    } else if (name === "Late") {
      columns.push({
        title: t("Station Name"),
        dataIndex: "loginlocationname",
        key: "loginlocationname",
        align: "center",
      });
      columns.push({
        title: <div>{"Location"}</div>,
        dataIndex: "location",
        key: "loginlatitude",
        width: "50%",
        align: "center",
        render: (_, record) => {
          const findLocation = locationList?.find(
            (item) => item?.location_id === String(record?.loginlocationid)
          );
          console.log("findLocation", findLocation);
          const hasother =
            findLocation?.login_from_anywhere === 1 ? true : false;
          console.log("hasother", hasother);
          return (
            <LocationCell
              lat={record.loginlatitude}
              lng={record.loginlongitude}
              hasother={hasother}
              locationName={record.loginlocationname}
            />
          );
        },
      });
      columns.push({
        title: t("Check-In Time"),
        dataIndex: "checkintime",
        key: "checkintime",
        align: "center",
        render: (checkintime) => {
          return `${checkintime}`;
        },
      });
    }
  }

  const config = {
    data: reportData,
    autoFit: false,
    xField: "numbers",
    yField: "type",
    color: name === "Leave" ? "#bd34eb" : "#126df6",
    label: {
      position: "right",
      style: {
        fill: "black",
      },
      formatter: (datum) => datum.numbers,
    },
    barStyle: {
      radius: [10, 10, 0, 0],
    },
    xAxis: {
      label: null,
      max: isNaN(max(map(reportData, "numbers")))
        ? 100
        : max(map(reportData, "numbers")) + 15,
      grid: {
        line: {
          style: {
            opacity: 0,
          },
        },
      },
    },
    yAxis: {
      label: {
        autoHide: false,
        autoRotate: true,
      },
    },
    columnStyle: {
      stroke: COLORS.BLACK,
      lineWidth: 1,
      cursor: "pointer",
      height: 10,
    },
    meta: {
      type: { alias: t(`Department {{reportType}}`, { reportType }) },
      numbers: { alias: t(name) },
    },
    coordinate: {
      type: "rect",
      transpose: true,
    },
  };

  useEffect(() => {
    if (displayModal) {
      getReportData();
    }
  }, [displayModal]);

  const getReportData = async () => {
    toggleReportLoader(true);
    const data = reduce(
      allDepartmentList,
      (result, department) => {
        result.push({
          department_id: department.department_id,
          type: department.department_name,
          numbers: 0,
        });
        return result;
      },
      []
    );
    let res = chain(list)
      .groupBy((x) => {
        if (x.departmentId) {
          return x.departmentId;
        }
        if (x.department_id) {
          return x.department_id;
        }
        if (x.departmentid) {
          return x.departmentid;
        } else {
          const firstElement =
            x.userdepartmentid[Object.keys(x.userdepartmentid)[0]];
          const randomIndex = Math.floor(Math.random() * firstElement?.length);
          return firstElement[randomIndex];
        }
      })
      .map((value, key) => {
        const department = find(data, { department_id: key });
        return {
          department_id: key,
          type: get(department, "type", null),
          numbers: size(value),
        };
      })
      .value();
    var final_res = differenceBy(data, res, "department_id");
    setReportData(concat(final_res, res));
    toggleReportLoader(false);

    const result = concat(final_res, res).filter((item) => item.numbers > 0);
  };

  const handleReportList = (data) => {
    if (
      data === null ||
      data === undefined ||
      data === "" ||
      data?.data?.department_id === ("" || null || undefined)
    ) {
      console.log("Clicked null data", data);
    } else {
      setReportList(true);
      setSelectedDept(data?.data?.type);
      console.log("detailedData--->", detailedData);
      setFilteredData(
        detailedData?.filter((e) => {
          if (e.departmentid) {
            return e.departmentid?.toString() === data?.data?.department_id;
          }
          if (e.departmentId) {
            return e.departmentid === data?.data?.department_id;
          }
          if (e.department_id) {
            return e.department_id === data?.data?.department_id;
          }
        })
      );
      toggleModal();
    }
  };

  const StyledTable = styled(Table)`
    .ant-table-content {
      overflow-x: auto;
      max-height: 500px;
      white-space: nowrap;
    }
    .ant-table-cell {
      padding: 10px;
    }
    .ant-table-thead .ant-table-cell {
      font-weight: bold;
      color: ${COLORS.SECONDARY_BLACK};
    }
    .ant-table-content {
      border: 1px solid #00000024;
      border-radius: 10px;
    }
    .non-white {
      background: #f9f9f9;
    }
    .ant-table-thead > tr > th::before {
      display: none !important;
    }

    .ant-table-cell-row-hover {
      background: #e3e8fc !important;
    }
  `;

  return (
    <>
      <StyledModal
        title={t("Today's {{name}} check-in report", { name })}
        visible={displayModal}
        onCancel={toggleModal}
        footer={null}
        destroyOnClose
      >
        <Row>
          <Col md={24} sm={24} xs={24} xl={24} key={key}>
            <Spin spinning={displayReportLoader}>
              <StyledColumn
                {...config}
                onReady={(plot) => {
                  plot.on("plot:click", (evt) => {
                    console.log("event-->", evt);
                    if (
                      evt.data !== null ||
                      evt.data !== undefined ||
                      evt.data !== ""
                    ) {
                      handleReportList(evt.data);
                    }
                  });
                }}
              />
            </Spin>
          </Col>
        </Row>
      </StyledModal>
      <SmallModal
        title={t("Today's {{name}} Report- {{selectedDept}} department", {
          name,
          selectedDept,
        })}
        open={reportList}
        footer={false}
        onCancel={() => setReportList(false)}
      >
        <StyledTable
          dataSource={filteredData}
          columns={columns}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="user_id"
          pagination={false}
          className="name_nowrap"
        />
      </SmallModal>
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  allDepartmentList: getAllDepartmentList(state),
  locationList: getLocations(state),
});

export default connect(mapStateToProps, null)(DepartmentAttendanceReport);
